import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: { order: ["path", "navigator"] },
    fallbackLng: "en",
    // lng: "en", //Default language
    resources: {
      en: {
        translations: require("./locales/en/translations.json"),
      },
      es: {
        translations: require("./locales/es/translations.json"),
      },
    },
    ns: ["translations"], //Namespaces (keys the resources uses)
    defaultNS: "translations", //Default namespace
  });

i18n.languages = ["en", "es"];
export default i18n;
